// @flow

const toCamelCase = (str: string): string =>
  str
    .replace(/'/, "")
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => (idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()))
    .replace(/[^\w]+/g, "");

export default toCamelCase;
